<template>
    <div class="Informativo-Principal">
        <PageTitle icon="fa fa-phone" main="Informativos"
            sub="Informativo para os colaboradores" />
        <div class="Info-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="INFORMATIVO" active><InfoCadastro /></b-tab>                                                                                                                        
                    <b-tab title="Painel" ><InfoPainel /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import InfoCadastro from '../informativo/InfoCadastro'
import InfoPainel from '../informativo/InfoPainel'
export default {
    name: 'InfoPrincipal',    
    components: { PageTitle, InfoCadastro,InfoPainel}
    
}
</script>

<style>

</style>






